export const appLanguages = [
	{
		tag: 'fr',
		name: 'Français',
		name_short: 'FR',
		code_iso2: 'fr',
		position: 2,
		display: true,
		default: true,
	},
	{
		tag: 'en',
		name: 'English',
		name_short: 'EN',
		code_iso2: 'en',
		position: 1,
		display: true,
		default: false,
	},
	{
		tag: 'de',
		name: 'Deutsch',
		name_short: 'DE',
		code_iso2: 'de',
		position: 3,
		display: false,
		default: false,
	},
];

const useAppLangs = () => {
	return appLanguages.filter((x) => x.display === true);
};

export default useAppLangs;
